import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';

import * as styles from './styles.css';

export default function ToolTip({ title, children, placement, iconClassName, trigger }) {
  return (
    <OverlayTrigger
      rootClose
      placement={placement}
      overlay={
        <Popover
          id="overload-right"
          title={title}
          className={styles.tooltip}
        >
          {children}
        </Popover>
      }
      trigger={trigger}
    >
      <i className={`${iconClassName}`} />
    </OverlayTrigger>
  );
}

ToolTip.defaultProps = {
  iconClassName: 'fa fa-fw text-primary fa-info-circle',
  placement: 'right',
  title: undefined,
  trigger: 'click',
};

ToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  iconClassName: PropTypes.string,
  placement: PropTypes.oneOf(['left', 'top', 'right', 'bottom']),
  title: PropTypes.string,
  trigger: PropTypes.string,
};

